// extracted by mini-css-extract-plugin
export default {"code":"Code_code__aADBc","placeholder":"Code_placeholder__C3Dko","light":"Code_light__8TiTc","dark":"Code_dark__gxL80","inline":"Code_inline__hIJW3"};